/**
 * Desktop nav dropdown
 * The "Over AduroLight" parent in the inline menu is a WordPress menu link, so
 * clicking it navigated away while the hover-opened dropdown snapped shut. The
 * page itself is the first item INSIDE the dropdown, so the parent link can act
 * as a pure toggle: click opens/closes (is-open beside the CSS :hover state),
 * outside clicks and Escape close. Hover behaviour is untouched.
 *
 * @package StandOut
 * @since 2.0.0
 */
import { $$ } from "@utils/dom";
export function initNavDropdown() {
    const parents = $$(".hero-slider__menu > .menu-item-has-children");
    if (parents.length === 0) {
        return;
    }
    const close = (except) => {
        parents.forEach((parent) => {
            if (parent !== except) {
                parent.classList.remove("is-open");
                parent.querySelector("a")?.setAttribute("aria-expanded", "false");
            }
        });
    };
    parents.forEach((parent) => {
        const trigger = parent.querySelector(":scope > a");
        if (!trigger) {
            return;
        }
        trigger.setAttribute("aria-expanded", "false");
        trigger.setAttribute("aria-haspopup", "true");
        trigger.addEventListener("click", (event) => {
            event.preventDefault();
            const open = parent.classList.toggle("is-open");
            trigger.setAttribute("aria-expanded", String(open));
            close(parent);
        });
    });
    document.addEventListener("click", (event) => {
        if (!parents.some((parent) => parent.contains(event.target))) {
            close();
        }
    });
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            close();
        }
    });
}
